// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/PrizeFundCampaign.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TPPhdDh73_3r3GHLWt_H {
  font-size: var(--campaign-prize-fund-font-desktop);
}
.TPPhdDh73_3r3GHLWt_H[data-has-many='true'] {
  font-size: var(--campaign-prize-fund-font-has-many);
}
.TPPhdDh73_3r3GHLWt_H[data-variant='prize-pool'] {
  font-size: var(--campaign-prize-fund-font-prize-pool);
  align-items: center;
}
.TPPhdDh73_3r3GHLWt_H[data-collapsed='true'] {
  align-items: center;
  font-size: var(--campaign-prize-fund-font-collapsed);
}
.gP8rlOx9cfbdDQ6rdz6o {
  font-size: var(--campaign-prize-fund-currency-desktop);
  margin-left: 3px;
}
.DpnyNJyMLEKPeHja6E9K {
}
._q1XclFv_8MmlrBlKQwg {
}
.gP8rlOx9cfbdDQ6rdz6o[data-collapsed='true'] .DpnyNJyMLEKPeHja6E9K,
.gP8rlOx9cfbdDQ6rdz6o[data-variant='prize-pool'] .DpnyNJyMLEKPeHja6E9K {
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--campaign-prize-currency-collapsed-desktop);
  line-height: 0.85;
  vertical-align: baseline;
  -webkit-text-stroke: 0.01px;
  background-image: var(--campaign-gradient-gold-text-currency);
}
.gP8rlOx9cfbdDQ6rdz6o[data-variant='prize-pool'] .DpnyNJyMLEKPeHja6E9K {
  line-height: 0.85;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .TPPhdDh73_3r3GHLWt_H {
    font-size: var(--campaign-prize-fund-font-mobile);
  }
  .TPPhdDh73_3r3GHLWt_H[data-collapsed='true'] {
    font-size: var(--campaign-prize-fund-font-collapsed-mobile);
  }
  .TPPhdDh73_3r3GHLWt_H[data-variant='prize-pool'] {
    height: fit-content;
    margin-top: -5px;
    margin-bottom: 2px;
  }
  .gP8rlOx9cfbdDQ6rdz6o {
    font-size: var(--campaign-prize-fund-currency-mobile);
  }
  .gP8rlOx9cfbdDQ6rdz6o[data-collapsed='true'] .DpnyNJyMLEKPeHja6E9K,
  .gP8rlOx9cfbdDQ6rdz6o[data-variant='prize-pool'] .DpnyNJyMLEKPeHja6E9K {
    font-size: var(--campaign-prize-currency-collapsed-mobile);
  }
  .gP8rlOx9cfbdDQ6rdz6o[data-collapsed='true'][data-has-many='false'] .DpnyNJyMLEKPeHja6E9K,
  .gP8rlOx9cfbdDQ6rdz6o[data-variant='prize-pool'][data-has-many='false'] .DpnyNJyMLEKPeHja6E9K {
    vertical-align: bottom;
  }
  .gP8rlOx9cfbdDQ6rdz6o[data-variant='prize-pool'] .DpnyNJyMLEKPeHja6E9K {
    line-height: 0.85;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .TPPhdDh73_3r3GHLWt_H {
    font-size: var(--campaign-prize-fund-font-portrait);
  }
  .gP8rlOx9cfbdDQ6rdz6o {
    font-size: var(--campaign-prize-fund-currency-portrait);
  }
  .gP8rlOx9cfbdDQ6rdz6o[data-collapsed='true'][data-has-many='false'] {
    margin-top: 0;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .TPPhdDh73_3r3GHLWt_H {
    font-size: var(--campaign-prize-fund-font-portrait);
  }
  .gP8rlOx9cfbdDQ6rdz6o {
    font-size: var(--campaign-prize-fund-currency-portrait);
  }
  .gP8rlOx9cfbdDQ6rdz6o[data-collapsed='true'][data-has-many='false'] {
    margin-top: 0;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .TPPhdDh73_3r3GHLWt_H {
    font-size: var(--campaign-prize-fund-font-landscape);
  }
  .gP8rlOx9cfbdDQ6rdz6o {
    font-size: var(--campaign-prize-fund-currency-landscape);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .TPPhdDh73_3r3GHLWt_H {
    font-size: var(--campaign-prize-fund-font-landscape);
  }
  .gP8rlOx9cfbdDQ6rdz6o {
    font-size: var(--campaign-prize-fund-currency-landscape);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/css/SingleViewPrizeFundCampaign.module.css"],"names":[],"mappings":"AAAA;EAEE,kDAAkD;AACpD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EAEE,sDAAsD;EACtD,gBAAgB;AAClB;AACA;AAEA;AACA;AAEA;AACA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2DAA2D;EAC3D,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,6DAA6D;AAC/D;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,iDAAiD;EACnD;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,qDAAqD;EACvD;EACA;;IAEE,0DAA0D;EAC5D;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;AAAA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,uDAAuD;EACzD;EACA;IACE,aAAa;EACf;AACF;AAAA;AAVA;AAAA;AAAA;AAAA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,uDAAuD;EACzD;EACA;IACE,aAAa;EACf;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,wDAAwD;EAC1D;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,wDAAwD;EAC1D;AACF;AAAA;AAAA;AAAA","sourcesContent":[".prizeContainer {\n  composes: prizeContainer from './base/PrizeFundCampaign.base.module.css';\n  font-size: var(--campaign-prize-fund-font-desktop);\n}\n.prizeContainer[data-has-many='true'] {\n  font-size: var(--campaign-prize-fund-font-has-many);\n}\n.prizeContainer[data-variant='prize-pool'] {\n  font-size: var(--campaign-prize-fund-font-prize-pool);\n  align-items: center;\n}\n.prizeContainer[data-collapsed='true'] {\n  align-items: center;\n  font-size: var(--campaign-prize-fund-font-collapsed);\n}\n.currency {\n  composes: currency from './base/PrizeFundCampaign.base.module.css';\n  font-size: var(--campaign-prize-fund-currency-desktop);\n  margin-left: 3px;\n}\n.prizeTextStyle {\n  composes: prizeTextStyle from './base/PrizeFundCampaign.base.module.css';\n}\n.prizeTextStyleAmount {\n  composes: prizeTextStyleAmount from './base/PrizeFundCampaign.base.module.css';\n}\n.currency[data-collapsed='true'] .prizeTextStyle,\n.currency[data-variant='prize-pool'] .prizeTextStyle {\n  height: 100%;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--campaign-prize-currency-collapsed-desktop);\n  line-height: 0.85;\n  vertical-align: baseline;\n  -webkit-text-stroke: 0.01px;\n  background-image: var(--campaign-gradient-gold-text-currency);\n}\n.currency[data-variant='prize-pool'] .prizeTextStyle {\n  line-height: 0.85;\n}\n@media (--campaign-mobile) {\n  .prizeContainer {\n    font-size: var(--campaign-prize-fund-font-mobile);\n  }\n  .prizeContainer[data-collapsed='true'] {\n    font-size: var(--campaign-prize-fund-font-collapsed-mobile);\n  }\n  .prizeContainer[data-variant='prize-pool'] {\n    height: fit-content;\n    margin-top: -5px;\n    margin-bottom: 2px;\n  }\n  .currency {\n    font-size: var(--campaign-prize-fund-currency-mobile);\n  }\n  .currency[data-collapsed='true'] .prizeTextStyle,\n  .currency[data-variant='prize-pool'] .prizeTextStyle {\n    font-size: var(--campaign-prize-currency-collapsed-mobile);\n  }\n  .currency[data-collapsed='true'][data-has-many='false'] .prizeTextStyle,\n  .currency[data-variant='prize-pool'][data-has-many='false'] .prizeTextStyle {\n    vertical-align: bottom;\n  }\n  .currency[data-variant='prize-pool'] .prizeTextStyle {\n    line-height: 0.85;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .prizeContainer {\n    font-size: var(--campaign-prize-fund-font-portrait);\n  }\n  .currency {\n    font-size: var(--campaign-prize-fund-currency-portrait);\n  }\n  .currency[data-collapsed='true'][data-has-many='false'] {\n    margin-top: 0;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .prizeContainer {\n    font-size: var(--campaign-prize-fund-font-landscape);\n  }\n  .currency {\n    font-size: var(--campaign-prize-fund-currency-landscape);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prizeContainer": `TPPhdDh73_3r3GHLWt_H ${___CSS_LOADER_ICSS_IMPORT_0___.locals["prizeContainer"]}`,
	"currency": `gP8rlOx9cfbdDQ6rdz6o ${___CSS_LOADER_ICSS_IMPORT_0___.locals["currency"]}`,
	"prizeTextStyle": `DpnyNJyMLEKPeHja6E9K ${___CSS_LOADER_ICSS_IMPORT_0___.locals["prizeTextStyle"]}`,
	"prizeTextStyleAmount": `_q1XclFv_8MmlrBlKQwg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["prizeTextStyleAmount"]}`
};
export default ___CSS_LOADER_EXPORT___;
